exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\r\n  min-height: 30px;\r\n  line-height: 30px;\r\n  padding:0 30px;\r\n}\r\n\r\n.text-muted {\r\n  color: #868e96;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/footer/footer.component.css
// module id = ../../../../../src/app/layout/home/footer/footer.component.css
// module chunks = main